export class Link {
  linkHref: string;
  linkId: string;
  postText: string;
  preText: string;
  tenantId: string;
  text: string;
  type: string;
}
